import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import i18n from './i18n'
import VueKeycloak from './plugins/keycloak'
import croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import iri from 'usail-vue-sdk/plugins/IriToId'
import VueApexCharts from 'vue-apexcharts'

const moment = require('moment-timezone')
require('moment/locale/es')

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueKeycloak, {
  realm: 'usail',
  url: process.env.VUE_APP_IDENTITY_HOST,
  clientId: 'usail-fleet-commander-for-web'
})

Vue.use(croppa)

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_KEY,
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.use(iri)

Vue.config.productionTip = false

Vue.keycloak
  .init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    promiseType: 'native',
    checkLoginIframe: process.env.NODE_ENV === 'production'
  })
  .then(function(authenticated) {
    if (!authenticated) {
      localStorage.setItem('callbackUrl', window.location.pathname)
    }
    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(function(e) {
    // eslint-disable-next-line no-console
    console.log(e)
    // eslint-disable-next-line no-console
    console.log('failed to initialize')
  })
